exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AssociateAccountSuccess_subtitle_1p7m {\n  margin-bottom: 40px;\n}\n", ""]);

// exports
exports.locals = {
	"subtitle": "AssociateAccountSuccess_subtitle_1p7m"
};